const strings = {
    es: {
        dataTable: {
            empty: 'Sin coincidencias en la busqueda',
            loading: 'Buscando.. por favor aguarde',
        }
    },
}

export default strings